module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-02@2x.1f714ba1.jpg";